<template>
  <div>
    <div>
      <vs-prompt @cancel="val = ''" blur @accept="submitData" @close="addSeason = false" :active.sync="addSeason"
        accept-text="Add" title="Add New Season">
        <div class="con-exemple-prompt">
          <vs-input-number v-model="season.season_num" label="Season Num:" min="1" />
          <vs-input placeholder="Season Title" v-model="season.title" />
        </div>
      </vs-prompt>
      <vs-button color="danger" type="filled" size="small" @click="addSeason = !addSeason">Add New Season</vs-button>
      <vs-tabs position="left">
        <vs-tab :label="'Season -' + season.season_num" v-for="(season, index) in movie.seasons" :key="index">
          <div class="con-tab-ejemplo">
            <Season :season="season" />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>
<script>
import Season from './Season.vue'
export default {
  data() {
    return {
      addSeason: false,
      seasons: [],
      season: {
        id: 0,
        title: '',
        season_num: 1,
        finish: false
      }
    }
  },
  watch: {
    'season.season_num': {
      handler(val) {
        this.sortData()
      },
      deep: true

    }
  },

  components: {
    Season
  },
  created() {
    this.season.season_num = this.movie.lastSeason + 1;
    this.fetchSeasons()
  },
  props: ['movie'],
  methods: {
    sortData() {
      this.season.title = this.season.season_num;
    },
    fetchSeasons() {
      this.axios.get(`${this.$apiUrl}/v2/movies/episodes/${this.movie.id}`).then(res => {
        this.seasons = res.data
      })
    },
    submitData() {
      this.loading = true;
      let data = new FormData();
      data.append('id', this.season.id)
      data.append('title', this.season.title)
      data.append('season_num', this.season.season_num)
      data.append('series', this.movie.id)
      data.append('finish', this.season.finish)
      this.axios.post(`${this.$apiUrl}/v2/seasons`, data).then(res => {
        window.location.reload()
      })
    }
  },

}
</script>